module.exports = __webpack_public_path__ + "img/katva_no.3e7d4b99.png";